import { eventTemplate } from "../../js/state-machine/events";
import { prefix } from "../../js/utilities";
import { matchers } from "../../js/validate-props";
import { defaultProps as calendarDefaultProps, schema as calendarSchema } from "./calendar";

export const componentName = "DatePicker";

export const defaultProps = Object.freeze({
    ...calendarDefaultProps,
    calendarButtonSrLabel: "Open calendar",
    invalidDateErrorMessage: "Invalid date",
    unavailableDateErrorMessage: "Unavailable date",
});

export const schema = Object.freeze({
    ...calendarSchema,
    calendarButtonSrLabel: matchers.string,
    invalidDateErrorMessage: matchers.string,
    unavailableDateErrorMessage: matchers.string,
});

export const eventMap = Object.freeze({
    selectDate: eventTemplate(componentName, "SelectDate"),
});

export const componentClasses = Object.freeze({
    datePicker: {
        base: `${prefix}date-picker`,
        invalid: `${prefix}date-picker--invalid`,
        sm: `${prefix}date-picker--sm`,
    },
    label: `${prefix}date-picker__label`,
    calendarButton: `${prefix}date-picker__calendar-button`,
    wrapper: `${prefix}date-picker__wrapper`,
    input: `${prefix}date-picker__input`,
    validationIcon: `${prefix}date-picker__validation-icon`,
    invalidFeedback: `${prefix}date-picker__invalid-feedback`,
    popup: {
        base: `${prefix}date-picker__popup`,
        positioning: `${prefix}date-picker__popup--positioning`,
        visible: `${prefix}date-picker__popup--visible`,
        hidden: `${prefix}date-picker__popup--hidden`,
    },
});

export const views = Object.freeze({
    datePicker: {
        valid: { classList: [`!${componentClasses.datePicker.invalid}`] },
        invalid: { classList: [componentClasses.datePicker.invalid] },
    },
    popup: {
        positioning: {
            classList: [
                componentClasses.popup.positioning,
                `!${componentClasses.popup.visible}`,
                `!${componentClasses.popup.hidden}`,
            ],
        },
        visible: {
            classList: [
                componentClasses.popup.visible,
                `!${componentClasses.popup.positioning}`,
                `!${componentClasses.popup.hidden}`,
            ],
        },
        hidden: {
            classList: [
                componentClasses.popup.hidden,
                `!${componentClasses.popup.positioning}`,
                `!${componentClasses.popup.visible}`,
            ],
        },
    },
});

// All functions bellow were extracted from input mask so we could add it here in an abstract way
// Once the input mask is enhanced this will be removed and imported from there

export const applyMask = (mask, maskChar, element) => {
    const enteredValue = element.value.split("").filter((i) => {
        return i.match(/[0-9]/g);
    });
    const mappedValue = mask.map((char, index) => {
        return char === maskChar
            ? { char, index, value: null, replace: true }
            : { char, index, replace: false };
    });
    mappedValue.forEach((item, i) => {
        if (item.char !== maskChar && i <= enteredValue.length) {
            enteredValue.splice(item.index, 0, item.char);
        }
    });
    if (enteredValue.length > mappedValue.length) {
        enteredValue.pop();
    }
    let maskedValue = enteredValue.join("");
    if (!maskedValue.match(/[0-9]/g)) {
        maskedValue = "";
    }
    return maskedValue;
};

export const maskInitChars = {
    numberChar: "9",
};

export const bindMask = (event, format, inputElement) => {
    const mask = format.split("");
    const maskChars = format.split("").filter((i) => {
        return i !== maskInitChars.numberChar;
    });
    const oldStart = event.target.selectionStart;
    if (event.data && !event.data.match(/[0-9]/g) && event.data !== " " && event.data !== "-") {
        inputElement.value = inputElement.value.replace(event.data, "");
        inputElement.value = applyMask(mask, maskInitChars.numberChar, inputElement);
        event.target.selectionStart = oldStart;
        event.target.selectionEnd = oldStart;
    } else {
        const checkCurrentSpot = (nextChar) => {
            // Check if current is mask char
            if (
                maskChars.includes(inputElement.value[nextChar - 1]) &&
                !maskChars.includes(inputElement.value[nextChar])
            ) {
                if (maskChars.includes(inputElement.value[oldStart - 1])) {
                    inputElement.selectionStart = nextChar + 1;
                    inputElement.selectionEnd = nextChar + 1;
                } else {
                    inputElement.selectionStart = nextChar;
                    inputElement.selectionEnd = nextChar;
                }
            } else {
                //Check if next char is mask char. If not take the next char place. If yes, find next available.
                if (maskChars.includes(inputElement.value[nextChar])) {
                    checkCurrentSpot(nextChar + 1);
                } else {
                    inputElement.selectionStart = nextChar;
                    inputElement.selectionEnd = nextChar;
                }
            }
        };
        if (event.inputType === "deleteContentBackward") {
            const isPreviousNumber = (char) => {
                if (maskChars.includes(inputElement.value[char - 1])) {
                    isPreviousNumber(char - 1);
                } else {
                    inputElement.selectionStart = char;
                    inputElement.selectionEnd = char;
                }
            };
            inputElement.value = applyMask(mask, maskInitChars.numberChar, inputElement);
            isPreviousNumber(oldStart);
        } else {
            inputElement.value = applyMask(mask, maskInitChars.numberChar, inputElement);
            checkCurrentSpot(oldStart);
        }
    }
};
